<div class="site-text">
    <p class="text">
        Desiderate intensificare lo scambio di fatture elettroniche con i vostri partner commerciali? Nell’elenco eDirectory.ch trovate tutte le aziende e le organizzazioni che collaborano con un fornitore di servizi di e-invoicing aderente a eDirectory.ch.
    </p>
    <p class="text">
        eDirectory.ch vi sostiene nell’identificazione dei partner commerciali domiciliati in Svizzera che desiderano inviare e/o ricevere e-fatture.
    </p>
    <p class="text">
        L’elenco del forum swissDIGIN è gestito da PostFinance SA e contribuisce a diffondere lo scambio elettronico di fatture in Svizzera.
    </p>
</div>